export default function Blobs({ variant = "hero" }) {
  if (variant === "hero") {
    return (
      <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="blob blob-violet animate-float-slow"
             style={{ width: 520, height: 520, top: "-120px", left: "-120px" }} />
        <div className="blob blob-pink animate-float-slower"
             style={{ width: 460, height: 460, top: "20%", right: "-140px" }} />
        <div className="blob blob-orange animate-float-slow"
             style={{ width: 380, height: 380, bottom: "-120px", left: "30%" }} />
        <div className="blob blob-blue animate-float-slower"
             style={{ width: 340, height: 340, bottom: "10%", right: "20%" }} />
      </div>
    );
  }
  if (variant === "soft") {
    return (
      <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="blob blob-violet animate-float-slow"
             style={{ width: 360, height: 360, top: "10%", left: "-80px", opacity: 0.35 }} />
        <div className="blob blob-pink animate-float-slower"
             style={{ width: 420, height: 420, bottom: "-80px", right: "-60px", opacity: 0.35 }} />
      </div>
    );
  }
  return null;
}
